import React from 'react';
import './columnHeader.scss';
import { AonCheckbox } from '../../../components/core/AonCheckbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["ratingNoti"] = "Ratings Notification";
    ColumnTitle["nameAndgroup"] = "Name & Group";
    ColumnTitle["DomiciledCountry"] = "Domiciled Country";
    ColumnTitle["AMBestRating"] = "AM Best Rating";
    ColumnTitle["outlookAndImplim"] = "Outlook/ Implication";
    ColumnTitle["sandPRating"] = "S&P Rating";
    ColumnTitle["outlook"] = "Outlook";
    ColumnTitle["additionalRatingINfo"] = "Additional Rating Information";
    ColumnTitle["NAICCode"] = "NAIC Code";
    ColumnTitle["IDNO"] = "I.D. No.";
})(ColumnTitle || (ColumnTitle = {}));
export var columns = function (handleSorting, sortColumn, sortBy, isLoading, onClickRow) {
    var RatingNotificationCell = function (info) {
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        return React.createElement("span", null,
            React.createElement(AonCheckbox, { style: style, disabled: info.data.isLoading, onClick: function (event) { return onClickRow(event, info.node.rowIndex); }, checked: info.getValue() }));
    };
    var additionalInfo = function (info) {
        var rowData = info.data;
        var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestCode) && !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingExplanation) &&
            !(rowData === null || rowData === void 0 ? void 0 : rowData.SpCode) && !(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingExplanation);
        return (!displayFlag ?
            React.createElement("span", null,
                React.createElement(FontAwesomeIcon, { className: 'info-icon', icon: faCircleInfo })) : null);
    };
    var headerConfig = function (headerProps) {
        if (headerProps.displayName === "Additional Rating Information") {
            return (React.createElement("div", { className: "sorting sorting-height" },
                React.createElement("span", null, headerProps.displayName)));
        }
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return isLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var NameAndGroupCell = function (info) {
        var rowData = info.data;
        return (React.createElement("div", { className: 'cell-height' },
            React.createElement("div", { className: 'text-ellipse' }, info.getValue()),
            React.createElement("div", { style: { color: 'grey' }, className: 'text-ellipse' }, rowData === null || rowData === void 0 ? void 0 : rowData.GroupName)));
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    return ([
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "IsUserSubscribedForRN", cellRenderer: RatingNotificationCell, headerName: ColumnTitle.ratingNoti, sortable: false, flex: 0.75, minWidth: 120 },
        { field: "CompanyName", cellRenderer: NameAndGroupCell, headerName: ColumnTitle.nameAndgroup, sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 150 },
        { field: "Country", headerName: ColumnTitle.DomiciledCountry, sortable: false, headerComponent: headerConfig, flex: 1, minWidth: 150 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "AmBestRating", headerName: ColumnTitle.AMBestRating, sortable: false, flex: 1, minWidth: 100, headerComponent: headerConfig, },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "AmBestRatingOutlook", headerName: ColumnTitle.outlookAndImplim, sortable: false, headerComponent: headerConfig, flex: 1, minWidth: 150 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "SpRating", headerName: ColumnTitle.sandPRating, sortable: false, flex: 0.5, minWidth: 110, headerComponent: headerConfig, },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "SpRatingOutlook", headerName: ColumnTitle.outlook, sortable: false, flex: 0.5, minWidth: 150, headerComponent: headerConfig, },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "AdditionalInfo", tooltipComponent: "AdditionalInfoRatingTooltip", tooltipField: "CompanyName", cellRenderer: additionalInfo, headerName: ColumnTitle.additionalRatingINfo, flex: 1, minWidth: 100, headerComponent: headerConfig },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "NaicCode", headerName: ColumnTitle.NAICCode, sortable: false, flex: 0.5, minWidth: 100, headerComponent: headerConfig, },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "FeinCode", headerName: ColumnTitle.IDNO, sortable: false, flex: 0.5, minWidth: 110, headerComponent: headerConfig, },
    ]);
};
export var GetRowHeight = function (params) {
    console.log(params.data);
    if (params.data.CompanyName && params.data.GroupName) {
        return 50;
    }
    else {
        return 30;
    }
};
